module.exports = __webpack_public_path__ + "static/media/image_11.744f7a01.png";